export const RIGHT_PANEL_WIDTH = 460;
export const DRAWER_TRANSITION_MS = 250;

export const RIGHT_PANEL_DOCKED_SX = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100dvh",
  zIndex: "drawer",
};

export const TRACKER_HEADER_SX = {
  height: "calc(64px + env(safe-area-inset-top, 0px))",
  flexShrink: 0,
  pt: "env(safe-area-inset-top, 0px)",
  "@media (max-width: 899.95px) and (max-height: 500px)": {
    height: "calc(52px + env(safe-area-inset-top, 0px))",
  },
};
